import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import {Card, FormControl, FormLabel} from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import {validacionWalmart} from "../endpoints";
import useToken from "../useToken";
import SignaturePad from 'react-signature-canvas';
import "../sigcanvas.css"
import Typography from "@material-ui/core/Typography";
import CardContent from "@mui/material/CardContent";
import SnackbarAlert from "../components/SnackbarAlert";

class CaminadoTickets extends React.Component{
    constructor(props) {
        super(props);
        this.sigCanvas = React.createRef(null);
        this.clear = this.clear.bind(this);
        this.save = this.save.bind(this);

        this.state = {
            valores :[],
            valores_originales : [],
            resultados :[],
            user: useToken.getUser(),
            cambios:[],
            image: '',
            open: false,
            message: '',
            severity: '',
        }

    }

    handleRadioChange = (event,valor,tipo) =>{
        let datos = this.state.valores
        if (tipo ==='acepta_sca'){
            let value = event.target.value === '1'
            const index = datos.indexOf(valor)
            datos[index].acepta_sca = value
        }
        else{
            let value = event.target.value === '1'
            const index = datos.indexOf(valor)
            datos[index].acepta_walmart = value
        }
        this.setState({valores:datos})
    };

    getValores = () =>{
        validacionWalmart.getValoresCaminadoTickets().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({valores:result});

        }).catch(error=> {
            console.log(error)
        });
    }


    refrescar =(estado,severity) =>{
        this.setState({ openSnack: false})
        if (severity){
            this.setState({
                openSnack: true,
                message: estado,
                severity: severity})
        }
    }

    submitForm = () => {
        this.setState({progress:true,disabled:true, open:false})
        let firma_sca = ''
        let firma_walmart = ''
        if (!this.state.user.perfil.includes('validador')){
            firma_sca = this.state.image
        }
        else{
            firma_walmart = this.state.image
        }
        const list={
            datos: this.state.valores,
            firma_sca: firma_sca,
            firma_walmart: firma_walmart
        }
        validacionWalmart.updateCaminadoTickets(list).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.refrescar("Ha ocurrido un error inesperado", "error")
            console.log(error)
        });

    }

    clear(){
        this.sigCanvas.current.clear()
    }

    save(){
        this.setState({image: this.sigCanvas.current.toDataURL("image/png")}, ()=>{
            this.submitForm()
        });
    }

    componentDidMount() {
        this.getValores();
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Caminado tickets
                </Typography>
                <Grid container spacing={2} alignItems="flex-end">
                    {this.state.valores.map((valor) => {
                        return <Grid item xs={12} key={(valor.id).toString()}>
                            <Card>
                                <CardContent>
                                    <FormControl>
                                        <FormLabel>{(valor.id).toString() + ". " + valor.preguntas + " -- DEPTOS: " + (valor.depto).toUpperCase() }  </FormLabel>
                                        {this.state.user.perfil.includes('validador') &&
                                            <RadioGroup
                                                onChange={(e) => {
                                                    this.handleRadioChange(e, valor, 'acepta_walmart')
                                                }}
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name={(valor.id).toString()}
                                            >
                                                <FormControlLabel checked={valor.acepta_walmart === true} value="1"
                                                                  control={<Radio/>} label="Cumple"/>
                                                <FormControlLabel checked={valor.acepta_walmart === false} value="0"
                                                                  control={<Radio/>} label="No cumple"/>
                                            </RadioGroup>}
                                        {!this.state.user.perfil.includes('validador') &&
                                            <RadioGroup
                                                onChange={(e) => {
                                                    this.handleRadioChange(e, valor, 'acepta_sca')
                                                }}
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name={(valor.id).toString()}
                                            >
                                                <FormControlLabel checked={valor.acepta_sca === true} value="1"
                                                                  control={<Radio/>} label="Cumple"/>
                                                <FormControlLabel checked={valor.acepta_sca === false} value="0"
                                                                  control={<Radio/>} label="No cumple"/>
                                            </RadioGroup>}
                                    </FormControl>
                                </CardContent>
                            </Card>
                        </Grid>
                    })}
                    <Grid item xs={12}>
                        <Typography variant="body1" gutterBottom>
                            Firmar:
                        </Typography>
                        <SignaturePad ref={this.sigCanvas} canvasProps={{className: "signatureCanvas"}}/>
                        <Button onClick={this.clear} size={"small"} variant="contained" color="primary">
                            Limpiar firma
                        </Button>
                    </Grid>
                    <Grid item xs={12} container spacing={2} justifyContent={"flex-end"}>
                        <Grid item>
                            <Button variant="contained" onClick={this.save} color="primary">
                                Guardar
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default CaminadoTickets;